import { Dispatch } from 'redux';
import { getEventSessionsByDate } from '../api/eventSessions';
import { getBffRequestBaseParams } from '../selectors/bff';
import { getEventSessionsByMonth } from '../selectors/event/pureSelectors';
import { CheckoutState } from '../state';
import { saveSessionsByMonth } from './event';

export const loadSessionsForMonth =
    (date: Date, timezone: string) =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const state = getState();
        const { eventId, env } = getBffRequestBaseParams(state);
        const eventSessions = getEventSessionsByMonth(state);

        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const month_year_key = `${year}_${month}`;

        if (eventSessions !== undefined && month_year_key in eventSessions) {
            return;
        }

        const sessions = await getEventSessionsByDate({
            env,
            eventId,
            date: `${year}-${month}-01`,
            tzIdentifier: timezone,
        });

        dispatch(
            saveSessionsByMonth({ [month_year_key]: sessions.eventDates }),
        );
    };
